import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TvIcon, CheckCircleIcon, XCircleIcon, ShieldCheckIcon } from 'lucide-react';
type Step = 'age' | 'country' | 'rejected';
interface PresselProps {
  onApproved: () => void;
}
export function Pressel({
  onApproved
}: PresselProps) {
  const [step, setStep] = useState<Step>('age');
  const [exiting, setExiting] = useState(false);
  const handleApprove = () => {
    setExiting(true);
    setTimeout(() => {
      onApproved();
    }, 600);
  };
  const handleAgeYes = () => setStep('country');
  const handleAgeNo = () => setStep('rejected');
  const handleCountryYes = () => handleApprove();
  const handleCountryNo = () => setStep('rejected');
  return <AnimatePresence data-id="element-247">
      {!exiting && <motion.div initial={{
      opacity: 1
    }} exit={{
      opacity: 0,
      scale: 1.02
    }} transition={{
      duration: 0.5
    }} className="fixed inset-0 z-[100] bg-zinc-950 flex items-center justify-center px-4" data-id="element-248">
          {/* Background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-emerald-500/8 rounded-full blur-3xl pointer-events-none" data-id="element-249" />

          <div className="relative w-full max-w-md" data-id="element-250">
            {/* Logo */}
            <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="flex items-center justify-center gap-2 mb-8" data-id="element-251">
              <TvIcon className="w-7 h-7 text-emerald-500" data-id="element-252" />
              <span className="text-white font-bold text-lg" data-id="element-253">Guía TV</span>
            </motion.div>

            <AnimatePresence mode="wait" data-id="element-254">
              {/* AGE QUESTION */}
              {step === 'age' && <motion.div key="age" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -30
          }} transition={{
            duration: 0.4
          }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center" data-id="element-255">
                  <div className="w-16 h-16 bg-emerald-500/10 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-256">
                    <ShieldCheckIcon className="w-8 h-8 text-emerald-400" data-id="element-257" />
                  </div>
                  <p className="text-zinc-500 text-sm font-medium uppercase tracking-widest mb-3" data-id="element-258">
                    Verificación de acceso
                  </p>
                  <h2 className="text-2xl sm:text-3xl font-black text-white mb-3 leading-tight" data-id="element-259">
                    ¿Sos mayor de{' '}
                    <span className="text-emerald-400" data-id="element-260">18 años</span>?
                  </h2>
                  <p className="text-zinc-500 text-sm mb-8" data-id="element-261">
                    Este contenido está dirigido a mayores de edad.
                  </p>
                  <div className="grid grid-cols-2 gap-4" data-id="element-262">
                    <button onClick={handleAgeYes} className="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-black font-black text-lg py-4 rounded-xl transition-all duration-200 hover:scale-105" data-id="element-263">
                      <CheckCircleIcon className="w-5 h-5" data-id="element-264" />
                      SÍ
                    </button>
                    <button onClick={handleAgeNo} className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 font-bold text-lg py-4 rounded-xl transition-all duration-200" data-id="element-265">
                      <XCircleIcon className="w-5 h-5" data-id="element-266" />
                      NO
                    </button>
                  </div>
                </motion.div>}

              {/* COUNTRY QUESTION */}
              {step === 'country' && <motion.div key="country" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -30
          }} transition={{
            duration: 0.4
          }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center" data-id="element-267">
                  <div className="text-5xl mb-6" data-id="element-268">🇦🇷</div>
                  <p className="text-zinc-500 text-sm font-medium uppercase tracking-widest mb-3" data-id="element-269">
                    Verificación de acceso
                  </p>
                  <h2 className="text-2xl sm:text-3xl font-black text-white mb-3 leading-tight" data-id="element-270">
                    ¿Sos de <span className="text-emerald-400" data-id="element-271">Argentina</span>?
                  </h2>
                  <p className="text-zinc-500 text-sm mb-8" data-id="element-272">
                    Esta guía está optimizada para el mercado argentino.
                  </p>
                  <div className="grid grid-cols-2 gap-4" data-id="element-273">
                    <button onClick={handleCountryYes} className="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-black font-black text-lg py-4 rounded-xl transition-all duration-200 hover:scale-105" data-id="element-274">
                      <CheckCircleIcon className="w-5 h-5" data-id="element-275" />
                      SÍ
                    </button>
                    <button onClick={handleCountryNo} className="flex items-center justify-center gap-2 bg-zinc-800 hover:bg-zinc-700 text-zinc-300 font-bold text-lg py-4 rounded-xl transition-all duration-200" data-id="element-276">
                      <XCircleIcon className="w-5 h-5" data-id="element-277" />
                      NO
                    </button>
                  </div>
                </motion.div>}

              {/* REJECTED */}
              {step === 'rejected' && <motion.div key="rejected" initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -30
          }} transition={{
            duration: 0.4
          }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center" data-id="element-278">
                  <div className="w-16 h-16 bg-red-500/10 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-279">
                    <XCircleIcon className="w-8 h-8 text-red-400" data-id="element-280" />
                  </div>
                  <h2 className="text-2xl font-black text-white mb-3" data-id="element-281">
                    Acceso no disponible
                  </h2>
                  <p className="text-zinc-400 text-base leading-relaxed" data-id="element-282">
                    Lo sentimos, este contenido no está disponible para vos en
                    este momento.
                  </p>
                </motion.div>}
            </AnimatePresence>

            {/* Step indicator */}
            {(step === 'age' || step === 'country') && <div className="flex justify-center gap-2 mt-6" data-id="element-283">
                <div className={`w-2 h-2 rounded-full transition-colors ${step === 'age' ? 'bg-emerald-400' : 'bg-emerald-500'}`} data-id="element-284" />
                <div className={`w-2 h-2 rounded-full transition-colors ${step === 'country' ? 'bg-emerald-400' : 'bg-zinc-700'}`} data-id="element-285" />
              </div>}
          </div>
        </motion.div>}
    </AnimatePresence>;
}